import { message } from 'antd';
import { api } from '$app/api';

export const sendRescheduleProposalRequest = async (bookingId, rescheduleAvailability) => {
  try {
    const res = await api.post(`/bookings/${bookingId}/triggerReschedule`, { rescheduleAvailability });
    return res;
  } catch (err) {
    message.error(err);
  }
};
